
import { defineComponent } from "vue";
export default defineComponent({
  props: ["email", "firstRow", "secondRow"]
});
